var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elegant-img__wrapper",attrs:{"loading":_vm.imgLoading ? 'yes' : 'no'}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"项目图片"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }